import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import cookie from "js-cookie";
import jwt from "jsonwebtoken";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./storage/Index";
import Routes from "./Routes";
import { rememberLogin } from "./views/Login/serviceLogin";
import { AUTH_LOGOUT, ERROR } from "./constant/types";

let token = cookie.get("token");
if (token) {
  jwt.verify(token, process.env.REACT_APP_KEY_SECRET, (err, decoded) => {
    if (err) {
      cookie.remove("token");
      token = null;
    }
  });
}
const render = () => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <Routes />
      </Provider>
    </React.StrictMode>,
    document.getElementById("root")
  );
};
if (token) {
  rememberLogin(token).then((res) => {
    if (res.type !== ERROR) store.dispatch(res);
    else store.dispatch({ type: AUTH_LOGOUT });
    render();
  });
} else {
  render();
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
